import {
  FieldErrorsImpl,
  FieldValues,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
  UseFormUnregister
} from 'react-hook-form';
import { AnswerView } from '../../interfaces/CommunicationHistory.type';
import { SupportIcon } from '@cp/src/assets/icons/SupportIcon';
import { WhatsappIcon } from '@cp/src/assets/icons/WhatsappIcon';
import { SKIP_TRACING_TYPES } from '@cp/pages/CaseDetails/feedbackForm/constants';
export interface FeedbackQuestion {
  questionTypes: Array<QuestionResponse> | null;
  clearInteraction?: boolean;
  resetFeedbackQuestionTypes?: boolean;
  isFeedbackFormDirty?: boolean;
  skipTracingInitialQuestions?: Array<QuestionResponse>;
  addedPhoneNumber?: string;
  addedIdentifier?: string;
}

export interface MetaDataOption {
  isDefault?: boolean;
  interactionLevel?: number;
  phoneNumberNotRequired?: boolean;
}
export interface Option {
  referenceId: string;
  text: string;
  sortOrder: number;
  metadata?: MetaDataOption;
}

export enum TIMESCOPE {
  PAST = 'PAST',
  FUTURE = 'FUTURE'
}

export interface QuestionResponse {
  referenceId: string;
  name: string;
  text: string;
  answerType: AnswerType;
  options: Option[];
  groupedOptions?: Array<Array<Option>>;
  defaultValue?: any;
  mandatory: boolean;
  supportedDateType?: TIMESCOPE;
  maxDate?: string;
  minDate?: string;
  defaultOptionReferenceId?: string;
  metadata?: any;
}

export enum InteractionType {
  CALL_BRIDGE = 'CALL_BRIDGE',
  FIELD_VISIT = 'FIELD_VISIT',
  SELF_CALL = 'SELF_CALL',
  SLASH = 'CALL_BRIDGE',
  WHATSAPP_CALL = 'WHATSAPP_CALL',
  WHATSAPP_TEXT = 'WHATSAPP_TEXT',
  INHOUSE_FIELD_VISIT = 'INHOUSE_FIELD_VISIT',
  ADDRESS_VERIFICATION = 'ADDRESS_VERIFICATION',
  SKIP_TRACING = 'SKIP_TRACING',
  SPADE = 'SPADE',
  AMEYO = 'AMEYO',
  HUMAN_REMINDER = 'HUMAN_REMINDER',
  GEN_AI_BOT = 'GEN_AI_BOT',
  WHATSAPP_CHAT_HRC = 'WHATSAPP_CHAT_HRC',
  INBOUND_CALL = 'INBOUND_CALL',
  BOT_REMINDER = 'BOT_REMINDER'
}

export enum PtpType {
  BROKEN_PTP = 'BROKEN_PTP',
  PTP_TODAY = 'PTP_TODAY',
  UPCOMING_PTP = 'UPCOMING_PTP'
}

export const getBrokenWtpInteractionTypeData = (interactionType: InteractionType) => {
  switch (interactionType) {
    case InteractionType.HUMAN_REMINDER:
      return {
        label: 'HRC',
        Icon: SupportIcon,
        bgColor: 'var(--blue-bg)'
      };
    case InteractionType.BOT_REMINDER:
      return {
        label: 'HRC',
        Icon: SupportIcon,
        bgColor: 'var(--blue-bg)'
      };
    case InteractionType.GEN_AI_BOT:
      return {
        label: 'Whatsapp',
        Icon: WhatsappIcon,
        bgColor: 'var(--green-light)'
      };
    case InteractionType.WHATSAPP_CHAT_HRC:
      return {
        label: 'Whatsapp',
        Icon: WhatsappIcon,
        bgColor: 'var(--green-light)'
      };
    default:
      return null;
  }
};

export const getPtpInformationTypeData = (ptpType: string) => {
  switch (ptpType) {
    case PtpType.BROKEN_PTP:
      return {
        ptpLabel: 'Broken PTP,',
        ptpBgColor: 'var(--pale-red)',
        textColor: 'var(--red-base)',
        borderColor: 'var(--red-border)'
      };
    case PtpType.PTP_TODAY:
      return {
        ptpLabel: 'PTP today,',
        ptpBgColor: 'var(--green-light)',
        textColor: 'var(--green-base)',
        borderColor: 'var(--navi-color-green-border)'
      };
    case PtpType.UPCOMING_PTP:
      return {
        ptpLabel: 'Upcoming PTP,',
        ptpBgColor: 'var(--green-light)',
        textColor: 'var(--green-base)',
        borderColor: 'var(--navi-color-green-border)'
      };
  }
};

export enum AnswerType {
  TEXT = 'TEXT',
  DATE = 'DATE',
  TIME = 'TIME',
  AMOUNT = 'AMOUNT',
  OPTIONS = 'OPTIONS',
  REMINDER = 'REMINDER',
  PHONE_NUMBER = 'PHONE_NUMBER',
  RADIO_OPTIONS = 'RADIO_OPTIONS',
  MULTI_IMAGE_UPLOAD = 'MULTI_IMAGE_UPLOAD',
  GROUPED_OPTIONS = 'GROUPED_OPTIONS',
  CHECKBOX_OPTIONS = 'CHECKBOX_OPTIONS',
  TEXTAREA = 'TEXTAREA',
  MULTI_AUDIO_UPLOAD = 'MULTI_AUDIO_UPLOAD'
}

export enum IFeedbackFormSource {
  FEEDBACK_FORM = 'FEEDBACK_FORM',
  ADD_INTERACTION_BUTTON = 'ADD_INTERACTION_BUTTON',
  WHATS_APP_CHATBOT = 'WHATS_APP_CHATBOT'
}

export interface IRenderingEngine {
  question: QuestionResponse;
  register: UseFormRegister<any>;
  fetchOption: (refId: string, questionId: string) => void;
  error: Partial<FieldErrorsImpl<any>>;
  toggleLoading: (loading: boolean) => void;
  interactionType?: InteractionType | SKIP_TRACING_TYPES;
  setValue: UseFormSetValue<any>;
  getValue: UseFormGetValues<any>;
  lan: string;
  customerId: string;
  source: IFeedbackFormSource;
  getValues?: UseFormGetValues<FieldValues>;
  dispatchFeedback?: React.Dispatch<FeedbackFormAction>;
  unregister: UseFormUnregister<any>;
  clearErrors: UseFormClearErrors<any>;
}

interface Feedback {
  questionReferenceId: string;
  optionReferenceId?: string;
  answerText?: string;
}

export enum FEEDBACK_FORM_STATES {
  NOT_SUBMITED,
  SUBMITED,
  PAGES_OVER
}

export enum ECallingType {
  AMEYO = 'AMEYO',
  SELF_CALL = 'SELF_CALL',
  CALL_BRIDGE = 'CALL_BRIDGE',
  SLASH = 'CALL_BRIDGE',
  WHATSAPP_CALL = 'WHATSAPP_CALL',
  WHATSAPP_TEXT = 'WHATSAPP_TEXT',
  HUMAN_REMINDER = 'HUMAN_REMINDER',
  UNDEFINED = 'undefined',
  SKIP_TRACING = 'SKIP_TRACING_TELE',
  WHATSAPP_CHAT_HRC = 'WHATSAPP_CHAT_HRC',
  VENDOR_POC = 'VENDOR_POC'
}

export enum ConnectedType {
  CONNECTED_CONTACT = 'Connected Contact',
  CALL_CONNECTION = 'Call Connection',
  SKIP_TRACING = 'Customer Outreach done via'
}

export interface FeedbackPayload {
  accountNumber: string;
  feedbacks: Feedback[];
  sourceType: string | null;
  recipientName: string;
  recipientPhoneNumber: string;
  recipientPhoneNumberCustomId: string;
  agentPhoneNumber: string;
  comments: string;
  interactionReminderDTO?: unknown;
  feedbackFormState?: FEEDBACK_FORM_STATES;
  interactionType?: ECallingType | SKIP_TRACING_TYPES | null;
  referenceId?: string;
  interactionMetadata?: Record<string, any>;
  agentReferenceId?: string;
  callId?: string;
}

export interface FeedbackFormAction {
  type: FeedbackFormKind;
  payload?: {
    selectedChip?: string;
    questionResponse?: Array<QuestionResponse>;
    error?: any;
    telephone?: string;
    comment?: string;
    loading?: boolean;
    initialQuestionId?: string;
    initialOptionId?: string;
    interactionId?: string | null;
    feedbackFormState?: FEEDBACK_FORM_STATES;
    isImageUpload?: boolean;
    telephoneNotRequired?: boolean;
    isDefaultCallRequired?: boolean;
  };
}
export enum FeedbackFormKind {
  SET_SELECTED_CHIP,
  REMOVE_SELECTED_CHIP,
  UPDATE_QUESTION_MAP,
  HANDLE_FORM_ERROR,
  UPDATE_TELEPHONES,
  UPDATE_COMMENT,
  BEFORE_API_CALL,
  SUCESSFUL_API_CALL,
  SET_LOADING,
  SET_INITIAL_QUESTION_ID,
  SET_INTERACTION_ID,
  SET_FEEDBACK_FORM_STATE,
  API_ERROR,
  RESET_STATE,
  ImageUploadStatus,
  TELEPHONE_REQUIRED
}

export interface IFeedbackForm {
  selectedChip: string | null;
  questionMap: Array<QuestionResponse> | null;
  error?: Partial<FieldErrorsImpl<any>>;
  telephone?: string | null;
  comment?: string;
  loading?: boolean;
  initialQuestionId: string;
  initialOptionId: string;
  interactionId?: string | null;
  feedbackFormState?: FEEDBACK_FORM_STATES;
  isImageUpload?: boolean;
  telephoneNotRequired?: boolean;
  isDefaultCallRequired?: boolean;
}

export const WAIT_TIME_BEFORE_FETCH_INTERACTION_FEEDBACK = 5000;
export const MAX_POLLING_TIME_FOR_INTERACTION_FEEDBACK = 20000;
export const MAX_FETCH_TRY =
  MAX_POLLING_TIME_FOR_INTERACTION_FEEDBACK / WAIT_TIME_BEFORE_FETCH_INTERACTION_FEEDBACK;
export enum CALL_BRIDGE_STATUSES {
  ANSWER = 'ANSWER',
  NO_ANSWER = 'NOANSWER',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  CALL_SENT = 'CALL_SENT',
  MISSED = 'MISSED',
  RETRY = 'RETRY',
  AGENT_NOT_READY = 'AGENT_NOT_READY',
  UNAUTHORISED = 'UNAUTHORISED',
  FAILED = 'FAILED',
  INITIATED = 'INITIATED',
  DEFAULT = 'DEFAULT'
}

export enum CALLING_MODES {
  CELL = 'CELL',
  LANDLINE = 'LANDLINE',
  AUTO_DIALLER = 'AUTO_DIALLER'
}

export interface CreateCallBridgeInteraction {
  accountNumber: string;
  sourceType: string;
  recipientName: string | null;
  recipientPhoneNumber: string | undefined;
  recipientPhoneNumberCustomId: string | null;
  callingMode: string;
  referenceId?: string;
}

export interface FieldFeedbackActionBtnProps {
  answerViews: AnswerView[];
  comments: string;
  gMapLocationUrl: string;
}
